<h1 mat-mdc-dialog-title>Add Subscription</h1>
<mat-dialog-content>
  <t4-container>
    <div class="row loading-container">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>Product</mat-label>
          <mat-select [(ngModel)]="selectedProduct" (selectionChange)="getPrice()" [disabled]="loading">
            @for (product of products; track product) {
            <mat-option [value]="product">{{product.Name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field appearance="outline">
          <mat-label>Monthly cost</mat-label>
          <input matInput placeholder="0" [disabled]="true" [ngModel]="price">
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <input matInput placeholder="0" [disabled]="true" [ngModel]="type">
        </mat-form-field>
      </div>
      @if (loading) {
      <div class="loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      }
    </div>
  </t4-container>
  </mat-dialog-content>
    <div mat-dialog-actions style="height: 36px; text-align: center; margin-top: 10px">
      <button mat-raised-button color="primary" (click)="save()">Save</button>
    </div>

